// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a90e0d8a","952":"a73dd758"}[chunkId] + ".chunk.js";
};